import { Text } from '$components'
import { DogIcon } from '$components'
import { AnimatedOutlet } from '$components'

export function NoPetsEmptyState() {
  return (
    <div className="w-full p-12 bg-neutral-50 rounded-3xl flex flex-col items-center justify-center text-center">
      <DogIcon className="size-12 text-indigo-500 mb-4" />

      <Text
        type="h3"
        className="mb-4 text-gray-900"
      >
        No pets yet
      </Text>

      <Text
        type="s"
        className="text-gray-600 max-w-sm"
      >
        This client doesn&apos;t have any pets registered yet. You can add pets to their profile when they bring one in.
      </Text>

      <AnimatedOutlet />
    </div>
  )
}
